import css from './index.module.scss';
import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/dg200/');

export default function Banner() {
    const { isMobile, useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const [floatVideo, setFloatVideo] = useState(false);

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        if (!isMobile) {
            new ScrollMagic.Scene({
                triggerElement: '.dg200 .dg200Banner .textBox',
            })
                .setClassToggle('.dg200 .dg200Banner .textBox', 'enter')
                .addTo(controller);
        }
    }, []);

    return (
        <div className={`dg200Banner ${css.dg200Banner} ${isMobile ? 'dg200Banner_h5' : 'dg200Banner_pc'}`}>
            <div className="imgBox">
                <EFPic
                    name={[`${isMobile ? 'h5/' : 'pc/'}1.webp`, `${isMobile ? 'h5/' : 'pc/'}1.jpg`]}
                    className="fullImgs"
                    alt={t('dg200.banner_title')}
                    aira-label={t('dg200.banner_title')}
                />
            </div>
            <div className="textBox">
                <p className="title">{t('dg200.banner_title')}</p>
                <p className="subTitle">{t('dg200.banner_subtitle')}</p>
            </div>
            {isMobile && <YouTubeVideoPlayer floatVideo={floatVideo} setFloatVideo={setFloatVideo} videoSrc="https://www.youtube.com/embed/ozVzv0jo_BM" />}
        </div>
    );
}
